export class TranslatorDashboardHeader {
  constructor($) {
    console.info('Initializing TranslatorDashboardHeader');
    this.$ = $;
    this.$el = this.$('.header');
    if(this.$el.length === 0) {
      return;
    }

    this.initTooltip();
  }

  initTooltip() {
    this.$el.find('.td-header-tooltip-notification').tooltip();
  }
}



// WEBPACK FOOTER //
// ./style-guide-extends/js/translator-dashboard/header.js